module.exports = __webpack_public_path__ + "img/type-2.2bb4810d.svg";